/*                                      */

/**
 *
 *
 */
export const VERSION = '5.44.0';
export const PUBLIC_VERSION = '5';
